import react, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, Tab, Tabs, MenuItem, InputLabel, FormControl, Paper } from "@mui/material";
import {
    Grid,
    Card,
    CardContent,
    Divider,
} from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import { Typography, Button, Checkbox, Fab, IconButton, InputAdornment, TextField, Stack, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ClearIcon from "@mui/icons-material/Clear";
import RouteIcon from "@mui/icons-material/AltRoute";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PersonIcon from "@mui/icons-material/Person";
import TimelineIcon from "@mui/icons-material/Timeline";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { TABS, ROLES, DATE_FORMATS } from "../../constants";

const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && ` position: relative; `} `;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "112px - 34px - 43.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; 
  margin: 0 auto; 
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;

export default function ReportCentral() {
    const label = { inputProps: { "aria-label": "Checkbox demo" } };
    const location = useLocation();
    const selectedTabProp1 = location.state?.selectedTabProp;
    const [loading, setLoading] = useState(false);
    // default start/end to today's date (local)
    const getTodayStr = () => {
        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    const todayStr = getTodayStr();
    const [accessChanges, setAccessChanges] = useState("");
    const [rowCount, setRowCount] = useState()
    const [rowCount1, setRowCount1] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [currentPage1, setCurrentPage1] = useState(1);
    const [paginationModel1, setPaginationModel1] = useState({ page: currentPage1 - 1, pageSize: 20, });
    const [hasSearched, setHasSearched] = useState(false);
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [filter, setFilter] = useState(false)
    const [startDate, setStartDate] = useState(todayStr)
    const [endDate, setEndDate] = useState(todayStr)
    const [callApi, setCallApi] = useState(false);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [openDialog, setOpenDialog] = useState(false);
    const [reason, setReason] = useState("");
    const [rejectData, setRejectData] = useState(null);
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState("");
    const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
    const [isSessionDisabled, setIsSessionDisabled] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        selectedTabProp1 || TABS.REGISTERED
    );
    const [active, setActive] = useState(null);
    const [accessModulesData, setAccessModulesData] = useState([]);

    useEffect(() => {
        if (!startDate && !endDate) {
            setIsSessionDisabled(false);
        }
    }, [startDate, endDate]);


    useEffect(() => {
        if (hasSearched) {
            if (active == 1) {
                downloadNoRoutePlanCreated()
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active === 2) {
                downloadForcedVisitClosedByAdmin()
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 3) {
                downloadLocationMisMatch();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 4) {
                downloadOverallAvgVisitsPerDay();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 5) {
                downloadAverageDailyVisitsPerUser();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 6) {
                downloadUsersBelowAvgVisitMark();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            // else if (active == 7) {
            //     setRowCount(0);
            //     setVisibleEmployees([]);
            // }
            else if (active == 8) {
               downloadFollowUp();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            // else if (active == 9) {
            //     setRowCount(0);
            //     setVisibleEmployees([]);
            // }
            else if (active == 10) {
                downloadFollowUpChanged();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 11) {
                downloadDailyVisitSummaryAt4PM();
                 // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 12) {
                downloadSummaryOne();
                 // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 13) {
                downloadSummaryTwo();
                 // setRowCount(0);
                // setVisibleEmployees([]);
            }
            else if (active == 14) {
                downloadAutoCloseVisitByCron();
                // setRowCount(0);
                // setVisibleEmployees([]);
            }
        }


    }, [paginationModel.page, paginationModel.pageSize, paginationModel1.page, paginationModel1.pageSize]);

    useEffect(() => {
        fetchAccessModules();
        fetchSessions();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers();
        }
        if (userData?.role === 'rsm') {
            getUsers('rsm', userData?.id);
        }
        if (userData?.role === 'asm') {
            getUsers('asm', userData?.id);
        }
    }, []);

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            if (response?.data) {
                setSessions(response.data);
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "zUcusyrsRs"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }


    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }

    const downloadNoRoutePlanCreated = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getNotRoutePlanCreatedUsers(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(1);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadNoRoutePlanCreated1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadNotRoutePlanCreatedUsers",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `No_Route_Plan_Created_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(1);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadForcedVisitClosedByAdmin = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getForceVisitClosedUsers(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(2);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadForcedVisitClosedByAdmin1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadForceVisitClosedUsers",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Forced_Visit_Closed_By_Admin_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(2);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadLocationMisMatch = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getLocationMismatchCount(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(3);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadLocationMisMatch1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadLocationMismatchCount",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Location_Mismatch_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(3);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }


    const downloadOverallAvgVisitsPerDay = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getOverallAvgVisitsPerDay(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(4);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadOverallAvgVisitsPerDay1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadOverallAvgVisitsPerDay",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Overall_Avg_Visits_Per_Day_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(4);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }


    const downloadAverageDailyVisitsPerUser = async () => {
        setLoading(true);
        try {
            

            setVisibleEmployees([]);
            setRowCount(0);
            setLoading(false);
            setActive(5);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadAverageDailyVisitsPerUser1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadAvgDailyVisitsPerUser",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Average_Daily_Visits_Per_User_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(5);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadUsersBelowAvgVisitMark = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getUsersBelowAvgVisitMark(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(6);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadUsersBelowAvgVisitMark1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadBelowAvgVisitsUsers",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Users_Below_Avg_Visit_Mark_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(6);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpPlanned = async () => {
        setLoading(true);
        try {
            // let data = {
            //     startDate: startDate,
            //     endDate: endDate,
            //     ownerName: rm,
            //     rsm: userData?.role == 'rsm' ? userData?.id : rsm,
            //     asm: userData?.role == 'asm' ? userData?.id : asm,
            // }
            // let result = await window.Platform.database.exportData("dashboard/downloadBelowAvgVisitsUsers",
            //     data
            // )
            // const blob = new Blob([result.data], {
            //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const now = new Date();
            // const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", `Users_Below_Avg_Visit_Mark_${formattedDate}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(7);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpPlanned1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadFollowupVisitsReport",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `FollowUp_Planned_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(7);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpPending = async () => {
        setLoading(true);
        try {
            // let data = {
            //     startDate: startDate,
            //     endDate: endDate,
            //     ownerName: rm,
            //     rsm: userData?.role == 'rsm' ? userData?.id : rsm,
            //     asm: userData?.role == 'asm' ? userData?.id : asm,
            // }
            // let result = await window.Platform.database.exportData("dashboard/downloadBelowAvgVisitsUsers",
            //     data
            // )
            // const blob = new Blob([result.data], {
            //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const now = new Date();
            // const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", `Users_Below_Avg_Visit_Mark_${formattedDate}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(9);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpPending1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadPendingFollowupVisitReport",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `FollowUp_Pending_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(9);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpCompleted = async () => {
        setLoading(true);
        try {
            // let data = {
            //     startDate: startDate,
            //     endDate: endDate,
            //     ownerName: rm,
            //     rsm: userData?.role == 'rsm' ? userData?.id : rsm,
            //     asm: userData?.role == 'asm' ? userData?.id : asm,
            // }
            // let result = await window.Platform.database.exportData("dashboard/downloadBelowAvgVisitsUsers",
            //     data
            // )
            // const blob = new Blob([result.data], {
            //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // const now = new Date();
            // const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", `Users_Below_Avg_Visit_Mark_${formattedDate}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(8);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpCompleted1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadCompletedFollowupsReport",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `FollowUp_Completed_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(8);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

     const downloadFollowUp = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getFollowUpVisitWithStatusReport(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(8);
        } catch (error) {
            setVisibleEmployees([]);
            setRowCount(0);
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUp1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadFollowUpVisitWithStatusReport",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `FollowUp_Completed_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(8);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }


    const downloadFollowUpChanged = async () => {
        setLoading(true);
        try {
             let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getFollowupChangedDateReport(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(10);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadFollowUpChanged1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadFollowupChangedDateReport",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `FollowUp_Changed_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(10);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadDailyVisitSummaryAt4PM = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel1.page,
                recordPerPage: paginationModel1.pageSize,
            }
            let results = await window.Platform.database.getDailyVisitSummaryAt4PM(data);
            setRowCount1(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(11);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadDailyVisitSummaryAt4PM1 = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadDailyVisitSummaryAt4PM",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Daily_Visit_Summary_At-4PM_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(11);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadSummaryOne = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel1.page,
                recordPerPage: paginationModel1.pageSize,
            }
            let results = await window.Platform.database.getSummaryOne(data);
            setRowCount1(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(12);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadSummaryOne1 = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadSummaryOne",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Visit_Summary-1_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(12);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadSummaryTwo = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel1.page,
                recordPerPage: paginationModel1.pageSize,
            }
            let results = await window.Platform.database.getSummaryTwo(data);
            setRowCount1(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(13);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadSummaryTwo1 = async () => {
        setLoading(true);
        try {
            let data = {
                startDate: startDate,
                endDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadSummaryTwo",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Visit_Summary-2_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(13);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadAutoCloseVisitByCron = async () => {
        setLoading(true);
        try {
                let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            }
            let results = await window.Platform.database.getAutoVisitClosedUsers(data);
            setRowCount(results?.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                idIndex: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            setLoading(false);
            setActive(14);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const downloadAutoCloseVisitByCron1 = async () => {
        setLoading(true);
        try {
            let data = {
                fromDate: startDate,
                toDate: endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            }
            let result = await window.Platform.database.exportData("dashboard/downloadAutoVisitClosedUsers",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Auto_Close_Visits_By_Server_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            setActive(14);
        } catch (error) {
            setLoading(false);
            setActive(null);
            console.error("Export error:", error);
        }
    }

    const handleTabChange = async (value, keepSelected = false) => {
        setVisibleEmployees([]);
        setActive(null);
        setFilter(false);
        setStartDate(todayStr);
        setEndDate(todayStr);
        setSelectedTab(value);
    };
    const renderTabContent = () => {

        if (selectedTab === 0) {
            return (<>
                <div className="d-flex justify-content-end align-items-center  py-2">
                    <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                    <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                        sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
                    >
                        {[10, 20, 30, 50, 100].map((role) => (
                            <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                        ))}
                    </Select>
                </div>
                <DataGridContainer
                    style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
                >
                    <DataGrid
                        className="payrollGrid"
                        density="compact"
                        rows={visibleEmployees || []}
                        columns={schoolColumns()}
                        sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
                        disableSelectionOnClick
                        disableRowSelectionOnClick
                        rowHeight={60}
                        pageSizeOptions={[10]}
                        rowCount={rowCount}
                        getRowId={(row, index) => `${row.idIndex}-${row.userName}-${row?.CreatedAt}` || index}
                        paginationModel={paginationModel}
                        paginationMode="server"
                        onPaginationModelChange={setPaginationModel}
                    />
                </DataGridContainer>
            </>
            );
        } else if (selectedTab === 1) {
            return (
                <>
                    <div className="d-flex justify-content-end align-items-center  py-2">
                        <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                        <Select
                            value={paginationModel1.pageSize}
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setPaginationModel1({ ...paginationModel1, pageSize: e.target.value }); setHasSearched(true) }}
                            sx={{ width: 90, fontSize: 14, fontWeight: "500" }}
                        >
                            {[10, 20, 30, 50, 100].map((role) => (
                                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                            ))}
                        </Select>
                    </div>
                    <DataGridContainer
                        style={{ height: !visibleEmployees?.length ? "200px" : "auto" }}
                    >
                        <DataGrid
                            className="payrollGrid"
                            density="compact"
                            rows={visibleEmployees || []}
                            columns={distributorColumn()}
                            sx={{ color: "black", fontSize: "13px", fontWeight: "600" }}
                            disableSelectionOnClick
                            disableRowSelectionOnClick
                            pageSizeOptions={[10]}
                            rowHeight={60}
                            filterMode="server"
                            rowCount={rowCount1}
                            getRowId={(row, index) => row.id ?? row.idIndex ?? row.employee_id ?? row.employee_name ?? row.username ?? index}
                            paginationModel={paginationModel1}
                            paginationMode="server"
                            onPaginationModelChange={setPaginationModel1}
                        />
                    </DataGridContainer>
                </>
            );
        }
    };

    const clearFilters = async () => {
        setLoading(true);
        setVisibleEmployees([]);
        setFilter(false)
        setStartDate(todayStr)
        setEndDate(todayStr)
        setRm("")
        setRsm("")
        setAsm("")
        setIsDateRangeDisabled(false);
        setIsSessionDisabled(false);
        setSelectedSession("");
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
        setAccessChanges([]);
        setRowCount(0);
        setActive(null);
        setLoading(false);
        // try {
        //   let data1 = {
        //     pageNumber: paginationModel.page,
        //     ownerName: "",
        //     status: 0
        //   }
        //   let results = await window.Platform.database.getRoutePlan(data1);
        //   const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        //   setRowCount(results?.data1)
        //   setAccessChanges(jsonArrayWithId);
        // } catch (error) {
        //   console.error(error);
        //   window.NotificationUtils.showError("Error Fetching Data");
        //   setLoading(false);
        // }
        // finally {
        //   setLoading(false)
        // }
    }

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );
        let result = [
            {
                field: "namw11",
                headerName: "Name",
                minWidth: 200,
                valueGetter: (params) => {
                    let name = params.row?.name;
                    return name?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                        .join(" ");
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row?.name?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                        .join(" ") || "N/A";

                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "username12",
                headerName: "User Name",
                minWidth: 150,
                valueGetter: (params) => {
                    let name = params.row.username;
                    return name;
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.username || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            (active == 1 || active == 2) && {
                field: "email12",
                headerName: "Email",
                minWidth: 200,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.email || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.email || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
           (active == 1 || active == 2 || active == 3  || active == 4 || active == 5 || active == 6 || active == 14 ) && {
                field: "mobile12",
                headerName: "Mobile No.",
                minWidth: 130,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.mobno || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.mobno || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
           (active == 1 || active == 2 || active == 3  || active == 4 || active == 5 || active == 6 || active == 14 ) && {
                field: "role12",
                headerName: "Role",
                minWidth: 130,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.role || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.role || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "area12",
                headerName: "Area",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.cluster || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.cluster || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            (active == 1 || active == 2 || active == 14 ) && {
                field: "baseAdd",
                headerName: "Base Address",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.baseAddress || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.baseAddress || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 2 && {
                field: "partyId12",
                headerName: "Party ID",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.partyId || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.partyId || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 2 && {
                field: "partyName12",
                headerName: "Party Name",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.schoolName || params.row.DistributorName || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                 {params.row.schoolName || params.row.DistributorName || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 4 && {
                field: "Avg Visits/Day",
                headerName: "Average Visit Per Day",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.avgVisitPerDay || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.avgVisitPerDay || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 8 && {
                field: "PartyId1",
                headerName: "Party ID",
                minWidth: 180,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.partyId || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.partyId || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 8 && {
                field: "followUpDate1",
                headerName: "Follow-Up Date",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.followUpDate || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.followUpDate || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 8 && {
                field: "completedVisitDate",
                headerName: "Completed Visit Date",
                minWidth: 190,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.completedVisitDate || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.completedVisitDate || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 8 && {
                field: "followUpRemark12",
                headerName: "Follow-Up Remark",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.followUpRemark || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.followUpRemark || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 8 && {
                field: "status12",
                headerName: "Status",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.status || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.status || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 10 && {
                field: "partyId1",
                headerName: "Party ID",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.partyId || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.partyId || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 10 && {
                field: "partyNamew12",
                headerName: "Party Name",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.partyName || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.partyName || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 10 && {
                field: "followUpDate123",
                headerName: "Follow-Up Date",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.followUpDate || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.followUpDate || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 10 && {
                field: "remark12321",
                headerName: "Follow-Up Remark",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.remark || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.remark || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 10 && {
                field: "ChangedTo(RoutePlanDate)",
                headerName: "Changed To Date (Route Plan Date)",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.changedToDate || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.changedToDate || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 14 && {
                field: "visitDate12131",
                headerName: "Visit Date",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.visitDate || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.visitDate || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            }
        ].filter(Boolean);
        return result;
    };

    const distributorColumn = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );
        let result = [
            {
                field: "employee_name1",
                headerName: "User Name",
                minWidth: 220,
                valueGetter: (params) => {
                    let name = params.row.employee_name;
                    return name?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ");
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.employee_name?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ") || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "reporting_manager1",
                headerName: "Reporting Manager",
                minWidth: 220,
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.reporting_manager || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.reporting_manager || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            active == 11 && {
                field: "first_school_in_time1",
                headerName: "First School In Time",
                minWidth: 180,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.first_school_in_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.first_school_in_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 11 && {
                field: "last_school_out_time",
                headerName: "Last School Out Time",
                minWidth: 180,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.last_school_out_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.last_school_out_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 11 && {
                field: "meeting_time1",
                headerName: "Meeting Time",
                minWidth: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            (active == 12 || active == 13) && {
                field: "visit_date1",
                headerName: "Visit Date",
                minWidth: 120,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.visit_date || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.visit_date || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 12 && {
                field: "first_visit_time1",
                headerName: "First Visit Start Time",
                minWidth: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.first_visit_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.first_visit_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 12 && {
                field: "last_visit_time1",
                headerName: "Last Visit End Time",
                minWidth: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.last_visit_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.last_visit_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 12 && {
                field: "meeting_time1",
                headerName: "Meeting Time",
                minWidth: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 12 && {
                field: "school_visit_count1",
                headerName: "School Visit Count",
                minWidth: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.school_visit_count || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.school_visit_count || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 12 && {
                field: "total_time_with_travel1",
                headerName: "Total Time Including Travel",
                minWidth: 200,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.total_time_with_travel || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.total_time_with_travel || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 13 && {
                field: "party_id11",
                headerName: "Party ID",
                minWidth: 170,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.party_id || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.party_id || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 13 && {
                field: "party_name11",
                headerName: "Party Name",
                minWidth: 170,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.party_name || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.party_name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 13 && {
                field: "visit_start_time11",
                headerName: "Visit Start Time",
                minWidth: 130,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.visit_start_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.visit_start_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 13 && {
                field: "visit_end_time123",
                headerName: "Visit End Time",
                minWidth: 130,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.visit_end_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.visit_end_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            active == 13 && {
                field: "meeting_time123",
                headerName: "Meeting Time",
                minWidth: 120,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.meeting_time || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
        ].filter(Boolean);
        return result;
    };

    return (
        <>
            {loading && <OpaqueLoading />}
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>

                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid">
                                <div className="row mb-2 align-items-end">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel
                                                sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                            >
                                                Select Session
                                            </InputLabel>
                                            <Select
                                                label="Select Session"
                                                value={selectedSession}
                                                disabled={isSessionDisabled}
                                                sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                onChange={(e) => {
                                                    const selected = sessions.find((item) => item.id === e.target.value);
                                                    setSelectedSession(e.target.value);

                                                    if (selected) {
                                                        // ✅ Convert UTC → IST (local date)
                                                        const start = new Date(selected.startDate);
                                                        const end = new Date(selected.endDate);

                                                        const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                            .toISOString()
                                                            .split("T")[0];
                                                        const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                            .toISOString()
                                                            .split("T")[0];

                                                        setStartDate(startIST);
                                                        setEndDate(endIST);

                                                        // ✅ Disable manual date range if session chosen
                                                        setIsDateRangeDisabled(true);
                                                    } else {
                                                        // ✅ If cleared, re-enable date inputs
                                                        setIsDateRangeDisabled(false);
                                                    }
                                                }}

                                            >
                                                <MenuItem value="" sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>
                                                    Select Session
                                                </MenuItem>
                                                {sessions.map((s) => (
                                                    <MenuItem key={s.id} value={s.id} sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>
                                                        {s.sessionName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row align-items-center mt-2">
                                    <div className="col-md-3 mt-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-2 mt-2">
                                        <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }}
                                            onClick={() => {
                                                setHasSearched(true);
                                                if (active === 1) return downloadNoRoutePlanCreated();
                                                if (active === 2) return downloadForcedVisitClosedByAdmin();
                                                if (active === 3) return downloadLocationMisMatch();
                                                if (active === 4) return downloadOverallAvgVisitsPerDay();
                                                if (active === 5) return downloadAverageDailyVisitsPerUser();
                                                if (active === 6) return downloadUsersBelowAvgVisitMark();
                                                // if (active === 7) return downloadFollowUpPlanned();
                                                if (active === 8) return downloadFollowUp();
                                                // if (active === 9) return downloadFollowUpPending();
                                                if (active === 10) return downloadFollowUpChanged();
                                                if (active === 11) return downloadDailyVisitSummaryAt4PM();
                                                if (active === 12) return downloadSummaryOne();
                                                if (active === 13) return downloadSummaryTwo();
                                                if (active === 14) return downloadAutoCloseVisitByCron();
                                            }}>
                                            Find
                                        </Button>
                                    </div>
                                    <div className="col-md-2 mt-2">
                                        <Button variant="contained" color="secondary" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                    {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-2">
                                        {active == 1 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }}
                                            onClick={() => { downloadNoRoutePlanCreated1() }}>
                                            Download
                                        </Button>
                                            : active == 2 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadForcedVisitClosedByAdmin1() }}>
                                                Download
                                            </Button>
                                                : active == 3 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadLocationMisMatch1() }}>
                                                    Download
                                                </Button>
                                                    : active == 4 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadOverallAvgVisitsPerDay1() }}>
                                                        Download
                                                    </Button>
                                                        : active == 5 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadAverageDailyVisitsPerUser1() }}>
                                                            Download
                                                        </Button>
                                                            : active == 6 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadUsersBelowAvgVisitMark1() }}>
                                                                Download
                                                            </Button>
                                                                // : active == 7 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadFollowUpPlanned1() }}>
                                                                //     Download
                                                                // </Button>
                                                                    : active == 8 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadFollowUp1() }}>
                                                                        Download
                                                                    </Button>
                                                                        // : active == 9 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadFollowUpPending1() }}>
                                                                        //     Download
                                                                        // </Button>
                                                                            : active == 10 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadFollowUpChanged1() }}>
                                                                                Download
                                                                            </Button>
                                                                                : active == 11 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadDailyVisitSummaryAt4PM1() }}>
                                                                                    Download
                                                                                </Button>
                                                                                    : active == 12 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadSummaryOne1() }}>
                                                                                        Download
                                                                                    </Button>
                                                                                        : active == 13 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadSummaryTwo1() }}>
                                                                                            Download
                                                                                        </Button>
                                                                                            : active == 14 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadAutoCloseVisitByCron1() }}>
                                                                                                Download
                                                                                            </Button>
                                                                                                : ""}
                                    </div>}
                                </div>
                            </div>
                        </Paper>
                        {selectedTab == 0 ?
                            <div className="buttons-grid">
                                <Button className="button-item"
                                    onClick={() => {
                                         setActive(1); 
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        //  downloadNoRoutePlanCreated() 
                                        }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px",
                                        },
                                        ...(active == 1 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    No Route Plan Created
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(2);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadForcedVisitClosedByAdmin() 
                                    }}
                                    sx={{
                                        borderRadius: "16px",
                                        fontSize: "12px",
                                        background: "#87CEEB",
                                        transition: "0.3s",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            fontSize: "12px",
                                            background: "green",
                                            color: "#fff",
                                        },
                                        ...(active == 2 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Forced Visit Closed By Admin
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(3);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadLocationMisMatch()
                                     }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px",
                                        },
                                        ...(active == 3 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Location Mismatch
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(4); 
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        //  downloadOverallAvgVisitsPerDay()
                                         }}
                                    sx={{
                                        borderRadius: "16px",
                                        transition: "0.3s",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 4 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Overall Avg Visits / Day
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(5);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadAverageDailyVisitsPerUser() 
                                    }}
                                    sx={{
                                        borderRadius: "16px",
                                        transition: "0.3s",
                                        background: "#87CEEB",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 5 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Average Daily Visits / User
                                </Button>

                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(6);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadUsersBelowAvgVisitMark()
                                     }}
                                    sx={{
                                        borderRadius: "16px",
                                        transition: "0.3s",
                                        background: "#87CEEB",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 6 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Users Below Avg Visit Mark
                                </Button>
                                {/* <Button className="button-item"
                                    onClick={() => { setActive(7); downloadFollowUpPlanned() }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        transition: "0.3s",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 7 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Follow Up Visits Planned
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { setActive(8); downloadFollowUpCompleted() }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 8 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Follow Up Visits Completed
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { setActive(9); downloadFollowUpPending() }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        transition: "0.3s",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 9 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Follow Up Visits Pending
                                </Button> */}
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(8);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadFollowUp()
                                     }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 8 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Follow Up
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(10); 
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        //  downloadFollowUpChanged() 
                                        }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 10 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Follow Up Visits Changed
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(14);  
                                         setVisibleEmployees([]);
                                         setRowCount(0);
                                        // downloadAutoCloseVisitByCron() 
                                    }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px"
                                        },
                                        ...(active == 14 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Auto Close Visit By Server
                                </Button>
                            </div>
                            :
                            <div className="buttons-grid">
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(11);  
                                         setVisibleEmployees([]);
                                         setRowCount1(0);
                                        // downloadDailyVisitSummaryAt4PM() 
                                    }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px",
                                        },
                                        ...(active == 11 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Daily Visit Summary @ 4 PM
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(12);  
                                         setVisibleEmployees([]);
                                         setRowCount1(0);
                                        // downloadSummaryOne()
                                     }}
                                    sx={{
                                        borderRadius: "16px",
                                        fontSize: "12px",
                                        background: "#87CEEB",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            fontSize: "12px",
                                            background: "green",
                                            color: "#fff",
                                        },
                                        ...(active == 12 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Visit Summary 1
                                </Button>
                                <Button className="button-item"
                                    onClick={() => { 
                                        setActive(13);  
                                         setVisibleEmployees([]);
                                         setRowCount1(0);
                                        // downloadSummaryTwo() 
                                    }}
                                    sx={{
                                        borderRadius: "16px",
                                        background: "#87CEEB",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        letterSpacing: "0.6px",
                                        color: "#000",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: 6,
                                            background: "green",
                                            color: "#fff",
                                            fontSize: "12px",
                                        },
                                        ...(active == 13 && {
                                            transform: "translateY(-6px)",
                                            boxShadow: 8,
                                            background: "green",
                                            color: "#fff",
                                        }),
                                    }}>
                                    Visit Summary 2
                                </Button>
                            </div>}
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        <StyledTabs
                            variant="fullWidth"
                            value={selectedTab}
                            onChange={(event, value) => handleTabChange(value)}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Discrepancy Reports" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} />

                            {<Tab label="Curated Reports" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} />}
                        </StyledTabs>
                        {loading && <OpaqueLoading />}

                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>
        </>
    );
}
